import React, { useEffect, useState } from "react";
import "../Styles/nav.css";

const Nav = () => {
  let [show, handleShow] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        handleShow(true);
      } else handleShow(false);
    });

    return () => {
      window.removeEventListener("scroll");
    };
  }, []);
  return (
    <div className={`nav ${show && "nav__black"}`}>
      {/* https://upload.wikimedia.org/wikipedia/commons/0/0f/Logo_Netflix.png */}

      <img
        className="nav__logo"
        src="https://download.logo.wine/logo/Netflix/Netflix-Logo.wine.png"
        alt="Netflix Logo"
      />
      <img
        className="nav__avartar"
        src="https://pbs.twimg.com/profile_images/1240119990411550720/hBEe3tdn_400x400.png"
        alt="Netflix Logo"
      />
    </div>
  );
};

export default Nav;
